import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { SkechersComparisonReq, SkechersPoOrderFilter } from "@project-management-system/shared-models";
import { DataSource, Repository } from "typeorm";
import { SkechersOrdersEntity } from "../entity/skechers-orders.entity";


@Injectable()
export class SkechersOrdersRepository extends Repository<SkechersOrdersEntity> {
    private dataSource: DataSource


    constructor(@InjectRepository(SkechersOrdersEntity) private skechersOrdersRepo: Repository<SkechersOrdersEntity>
    ) {
        super(skechersOrdersRepo.target, skechersOrdersRepo.manager, skechersOrdersRepo.queryRunner);
    }

    async getDistinctPoNumbers(): Promise<any[]> {
        const query = this.createQueryBuilder('o')
            .select(`DISTINCT po_number`)

        return await query.getRawMany()
    }

    async getSkechersOrderDataRepo(req?: SkechersPoOrderFilter): Promise<any[]> {
        const query = this.createQueryBuilder('o')
            .select(`*`)
        if (req.poNumber !== undefined) {
            query.andWhere(`o.po_number ='${req.poNumber}'`)
        }
        return await query.getRawMany()
    }


    async getSkechersorderAcceptanceRepo(req?: SkechersPoOrderFilter): Promise<any[]> {
        const query = this.createQueryBuilder('o')
            .select(`*`)
        if (req.poNumber !== undefined) {
            query.andWhere(`o.po_number ='${req.poNumber}'`)
        }
        query.andWhere(`o.status != 'ACCEPTED'`);
        return await query.getRawMany()
    }

    async getordercomparationData(req?: SkechersComparisonReq): Promise<any[]> {
        const query = this.createQueryBuilder('o')
            .select(`*`)
        if (req.poNumber !== undefined) {
            query.andWhere(`o.po_number ='${req.poNumber}'`)
        }

        return await query.getRawMany()
    }

}